import{STYLE_TAG_ID as r}from"./STYLE_TAG_ID";export var DEFAULT_DISPLAY_CONFIG={styleTagId:r};